// @flow

import React, {createElement} from 'react'
import {render} from 'react-dom'
import axios from 'axios'
import Raven from 'raven-js'
import {createStore, applyMiddleware} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {Provider as StoreProvider} from 'react-redux'
import {AppContainer} from 'react-hot-loader'
import createRavenMiddleware from 'raven-for-redux'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'

import amplitude from '$src/analytics/amplitude'
import rootReducer from '$src/state'
import Root from './root/components/Root'
import './index.css'

import {selectIdTokenFromLocalStorage} from '$src/auth/selectors'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
axios.defaults.headers.common['Authorization'] = selectIdTokenFromLocalStorage()

const middlewares = []

const sagaMiddleware = createSagaMiddleware()
middlewares.push(sagaMiddleware)

if (process.env.REACT_APP_SENTRY_URL) {
  Raven.config(process.env.REACT_APP_SENTRY_URL, {release: process.env.REACT_APP_VERSION}).install()
  const ravenReduxMiddleware = createRavenMiddleware(Raven, {
    stateTransformer: (state) => {
      const sanitized = cloneDeep(state)
      if (get(sanitized, 'auth.tokensState.idToken')) sanitized.auth.tokensState.idToken = '<sanitized>'
      if (get(sanitized, 'auth.tokensState.refreshToken')) sanitized.auth.tokensState.refreshToken = '<sanitized>'
      return sanitized
    },
  })
  middlewares.push(ravenReduxMiddleware)
}

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(...middlewares)
)

amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY)

const renderApp = (component: any) =>
  render(
    <AppContainer>
      <StoreProvider store={store}>
        {createElement(component, {runSaga: sagaMiddleware.run})}
      </StoreProvider>
    </AppContainer>,
    document.getElementById('root')
  )

renderApp(Root)

if (module.hot) {
  // $FlowFixMe
  module.hot.accept('./root/components/Root', () => {
    const nextRoot = require('./root/components/Root').default
    renderApp(nextRoot)
  })
}



// WEBPACK FOOTER //
// ./src/index.js